import { Link } from "react-router-dom";
import { useTheme } from "next-themes";
import { useTranslation } from "react-i18next";
import logoLight from "@/assets/logo-light.svg";
import logoDark from "@/assets/logo-dark.svg";

export default function Footer() {
  const { t } = useTranslation();
  const { resolvedTheme } = useTheme();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-background/80 backdrop-blur-sm print:hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-3">
              <img
                src={resolvedTheme === "dark" ? logoDark : logoLight}
                alt="Veriksa"
                className="h-6 w-auto object-contain"
              />
            </Link>
            <p className="text-xs text-muted-foreground leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>

          {/* Product */}
          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-muted-foreground mb-3">
              {t("footer.product")}
            </div>
            <ul className="space-y-2">
              {[
                { to: "/analyze", label: t("nav.analyze") },
                { to: "/pricing", label: t("nav.pricing") },
                { to: "/dashboard", label: t("nav.dashboard") },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-xs text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-muted-foreground mb-3">
              {t("footer.company")}
            </div>
            <ul className="space-y-2">
              {[
                { to: "/about", label: t("footer.about") },
                { to: "/about#api", label: t("footer.apiDocs") },
                { to: "/about#contact", label: t("footer.contact") },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-xs text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-muted-foreground mb-3">
              {t("footer.legal")}
            </div>
            <ul className="space-y-2">
              {[
                { to: "/terms", label: t("footer.terms") },
                { to: "/privacy", label: t("footer.privacy") },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-xs text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-border pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-mono text-muted-foreground">
            &copy; {year} Veriksa — {t("footer.rights")}
          </p>
          <p className="text-xs font-mono text-muted-foreground">
            {t("footer.madeIn")}
          </p>
        </div>
      </div>
    </footer>
  );
}
